import { useTranslation } from "react-i18next";
import { MapPinOff } from "lucide-react";

// خارج النطاق الجغرافي: لا تُفتح شاشة QR ولا الكاميرا قبل الدخول ضمن نطاق الفرع.
export const GeoNotice = ({ check, onClose }) => {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-4 py-6 text-center" data-testid="geo-notice">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-destructive/15 shadow-neu-in">
        <MapPinOff className="h-9 w-9 text-destructive" />
      </span>
      <div>
        <p className="text-xl font-black text-destructive" data-testid="geo-notice-title">{t("geoGate.title")}</p>
        <p className="mx-auto mt-2 max-w-xs text-sm font-semibold text-muted-foreground">
          {t("geoGate.reason", { distance: Math.round(check.distance_m), radius: check.radius_m })}
        </p>
      </div>
      <p className="max-w-xs text-xs text-muted-foreground">{t("geoGate.hint")}</p>
      <button type="button" data-testid="geo-notice-close" onClick={onClose}
        className="rounded-2xl bg-primary px-6 py-3 text-sm font-bold text-primary-foreground">
        {t("app.close")}
      </button>
    </div>
  );
};
